import { render } from "./designPeoplePrint.vue?vue&type=template&id=16a969c6"
import script from "./designPeoplePrint.vue?vue&type=script&lang=js"
export * from "./designPeoplePrint.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__